import { JWT } from "aws-amplify/auth";

const sign = require("jwt-encode");
const decode = require("jwt-decode");
const AUTH_TOKEN = "AuthToken";
const RAW_TOKEN = "RawAuthToken";

export const getToken = () => {
  return localStorage.getItem(AUTH_TOKEN);
};

// Nueva función para obtener el token raw para APIs
export const getRawToken = () => {
  return localStorage.getItem(RAW_TOKEN);
};

export const setToken = (accessToken: JWT | undefined) => {
  if (accessToken) {
    const token = sign(accessToken, "sBJ*zkF8i#CK!qCD");
    localStorage.setItem(AUTH_TOKEN, token);
    // También guardamos el token raw para APIs
    localStorage.setItem(RAW_TOKEN, accessToken.toString());
  }
};

export const removeToken = () => {
  console.log("removiendo token!!");
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(RAW_TOKEN);
};
